<!-- add modal -->
<div
  class="modal fade"
  id="add"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Thêm Nhà Xuất Bản
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Đóng"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-publisher
          (closeModalEvent)="closeModalAdd()"
        ></app-add-publisher>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
          Đóng
        </button>
      </div>
    </div>
  </div>
</div>

<!-- edit modal -->
<!-- <div
  class="modal fade"
  id="edit"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ publisherI18n?.editTitleI18n }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-edit-publisher
          (closeModalEvent)="closeModalEdit()"
          [id]="id"
        ></app-edit-publisher>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ publisherI18n?.closeButtonI18n }}
        </button>
      </div>
    </div>
  </div>
</div>
 -->